module.exports = {
	"name": "scality-s3",
	"version": "9.5.0",
	"private": true,
	"engines": {
		"node": ">=22"
	},
	"devDependencies": {
		"connect-history-api-fallback": "1.3.0",
		"detect-port": "1.0.1",
		"enzyme": "^2.7.1",
		"eslint": "^9.24.0",
		"eslint-config-airbnb": "^19.0.4",
		"eslint-config-scality": "scality/guidelines#8.3.0",
		"eslint-plugin-react": "^7.37.5",
		"find-cache-dir": "0.1.1",
		"http-proxy-middleware": "0.17.2",
		"jest": "22",
		"react-addons-test-utils": "^15.4.2",
		"react-test-renderer": "^15.5.4",
		"strip-ansi": "3.0.1",
		"webpack-dev-server": "1.16.2"
	},
	"dependencies": {
		"autoprefixer": "6.5.1",
		"babel-core": "6.17.0",
		"babel-jest": "16.0.0",
		"babel-loader": "6.2.5",
		"babel-preset-react-app": "^1.0.0",
		"bootstrap": "^3.3.7",
		"bootstrap-daterangepicker": "^2.1.30",
		"chalk": "1.1.3",
		"css-loader": "0.25.0",
		"d3": "^3.4.4",
		"dotenv": "2.0.0",
		"express": "4.18.1",
		"extract-text-webpack-plugin": "1.0.1",
		"file-loader": "0.9.0",
		"filesize": "3.3.0",
		"font-awesome": "^4.7.0",
		"fs-extra": "0.30.0",
		"gzip-size": "3.0.0",
		"html-webpack-plugin": "2.24.0",
		"jquery": "^3.3.1",
		"json-loader": "0.5.4",
		"moment": "^2.20.1",
		"morgan": "1.10.0",
		"normalize.css": "^5.0.0",
		"null-loader": "^0.1.1",
		"nvd3": "^1.8.6",
		"object-assign": "4.1.0",
		"postcss-loader": "1.0.0",
		"promise": "7.1.1",
		"prop-types": "^15.5.10",
		"react": "^15.4.1",
		"react-bootstrap": "^0.31.3",
		"react-bootstrap-daterangepicker": "^4.1.0",
		"react-debounce-input": "^3.2.0",
		"react-dev-utils": "^0.3.0",
		"react-dom": "^15.4.1",
		"react-json-view": "1.16.1",
		"react-nvd3": "^0.5.7",
		"react-router-dom": "^4.2.2",
		"react-validation": "^2.10.9",
		"reactable": "^0.14.1",
		"recursive-readdir": "2.1.0",
		"rimraf": "2.5.4",
		"style-loader": "0.13.1",
		"superagent": "^3.1.0",
		"webpack": "1.13.2",
		"whatwg-fetch": "1.0.0"
	},
	"resolutions": {
		"webpack-dev-server/open": "^8.4.0",
		"handlebars": "^4.7.7",
		"eventsource": "^2.0.2",
		"ejs": "^3.1.7"
	},
	"scripts": {
		"start": "node scripts/start.js",
		"build": "node scripts/build.js",
		"test": "node scripts/runTests.js --env=jsdom",
		"lint": "eslint $(git ls-files '*.js')",
		"lint_md": "mdlint $(git ls-files '*.md')"
	},
	"jest": {
		"verbose": true,
		"testURL": "http://localhost/",
		"moduleFileExtensions": [
			"jsx",
			"js",
			"json"
		],
		"moduleNameMapper": {
			"^.+\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$": "<rootDir>/config/jest/FileStub.js",
			"^.+\\.css$": "<rootDir>/config/jest/CSSStub.js"
		},
		"setupFiles": [
			"<rootDir>/config/polyfills.js",
			"<rootDir>/src/utils/test-utils/browserMocks.js"
		],
		"testPathIgnorePatterns": [
			"<rootDir>/(build|docs|node_modules)/"
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./package.json
 ** module id = 599
 ** module chunks = 0
 **/